// extracted by mini-css-extract-plugin
export default {"button":"omakasePlanBanner_button__-QbjG","bannerImage":"omakasePlanBanner_bannerImage__-JnF-"};